// extracted by mini-css-extract-plugin
export default {"component":"RightBodyComponent_component__13NQL"};